export const defaultPopoverInit = {
  anchorOrigin: { vertical: "bottom", horizontal: "center" },
  transformOrigin: { vertical: "top", horizontal: "center" },
  PaperProps: {
    sx: { mt: 3 },
  },
};
